const setReady = (state) => {
  state.ready = true;
};

const setPoiList = (state, poiList) => {
  state.poiList = poiList;
};

const setMap = (state, map) => {
  state.map.center.lat = map.center.lat;
  state.map.center.lng = map.center.lng;
  state.map.style = map.style;
  state.map.project.lat = map.project.lat;
  state.map.project.lng = map.project.lng;
};

const setSelectedPoiId = (state, poiId) => {
  state.selectedPoiId = poiId;
};

const setFilters = (state, filters) => {
  state.filters = filters;
};

const sortByOrderId = (state) => {
  state.poiList.sort((a, b) => a.orderId - b.orderId);
};

const sortByTravelTime = (state, travelMode) => {
  switch (travelMode) {
    case 'walk':
      state.poiList.sort((a, b) => a.travelTime.walk - b.travelTime.walk);
      state.travelMode = travelMode;
      break;
    case 'transit':
      state.poiList.sort((a, b) => a.travelTime.transit - b.travelTime.transit);
      state.travelMode = travelMode;
      break;
    case 'drive':
      state.poiList.sort((a, b) => a.travelTime.drive - b.travelTime.drive);
      state.travelMode = travelMode;
      break;
    default: break;
  }
};

const setArchitecture = (state, slides) => {
  state.architecture = slides;
};

export default {
  setReady,
  setPoiList,
  setMap,
  setSelectedPoiId,
  setFilters,
  sortByOrderId,
  sortByTravelTime,
  setArchitecture
};



// WEBPACK FOOTER //
// ./src/store/modules/neighbourhood/mutations.js